import { UPDATE_TOAST_INFO } from "./types"

export const updateToastInfo = (data) => {
    return {
        type: UPDATE_TOAST_INFO,
        data
    }
}